<template>
    <span v-if="timeOnly" v-text="moment(date).format('LT')" />
    <v-tooltip v-else bottom>
        <template v-slot:activator="{ on }">
            <span v-if="dateOnly" v-on="on" v-text="moment(date).format(longDateFormat(false, false, true, true))" />
            <span v-else v-on="on" v-text="moment(date).format('L') + ' ' + moment(date).format('LTS')" />
        </template>
        <span v-if="dateOnly" v-text="moment(date).format(longDateFormat(false, true, true))" />
        <span v-else v-text="moment(date).format('LLLL')" />
    </v-tooltip>
</template>

<script>
import Vue from "vue";
import moment from "moment";

// vuex
import { mapGetters } from "vuex";

export default Vue.extend({
    data() {
        return {
            moment,
        };
    },
    props: {
        date: {
            type: [Date, String],
            required: true,
        },
        timeOnly: {
            type: Boolean,
            default: false,
        },
        dateOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(["userDateFormat", "longDateFormat"]),
    },
});
</script>
